export default __webpack_public_path__ + "static/media/blueTwitterIcon.c9d69acf.png";